import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { InlineLoader, Dropdown, RadioGroup, Radio } from 'cat-ecommerce-alloy';
import sortBy from 'lodash/sortBy';
import pmStyles from '../PMKitWidget.scss';
import UnitOfMeasureToggle from '@app/components/common/UnitOfMeasureToggle';

const ServiceOptionsDropdown = ({
  selectedUnit,
  setSelectedUnit,
  pmKitOptions,
  itemToString,
  pmKitsList,
  pmKitErrors,
  getPMKitValue,
  selectedPMKit
}) => {
  const [t] = useTranslation();
  const catGroupHead = {
    displayValue: t('PM_KIT_TYPE2'),
    value: 'Caterpillar',
    itemType: 'optGroupHead'
  };
  const dealerGroupHead = {
    displayValue: t('PM_KIT_TYPE1'),
    value: 'Dealer',
    itemType: 'optGroupHead'
  };
  const pmKitDropdown = () => {
    let catKitList = [];
    let dealerKitList = [];
    //Sorting the list based on firstInterval value
    const sortedCatKitList = sortBy(pmKitsList, 'firstInterval');
    sortedCatKitList?.length > 0 &&
      sortedCatKitList.map(item => {
        const pmKitObj = {
          displayValue: `${item.description}`,
          value: `${item.serviceOptionID}`
        };
        //This logic seperate the Caterpillar and Dealer kits
        if (item.isCATKit) {
          catKitList.push(pmKitObj);
        } else {
          dealerKitList.push(pmKitObj);
        }
      });
    dealerKitList = dealerKitList.length
      ? [dealerGroupHead, ...dealerKitList]
      : [];
    catKitList = catKitList.length ? [catGroupHead, ...catKitList] : [];
    //This is final array that we pass to dropdown component with Dealer and Caterpillar group heads
    return [...dealerKitList, ...catKitList];
  };

  return (
    <div>
      <div className={`${pmStyles['us-metric-box']}`}>
        <UnitOfMeasureToggle
          name="radioButtonVariant"
          setUnitOfMeasure={setSelectedUnit}
          showToggle={true}
          unitOfMeasure={selectedUnit}
        />
      </div>
      {pmKitOptions.isLoading ? (
        <InlineLoader />
      ) : (
        <>
          <Dropdown
            itemToString={itemToString}
            items={pmKitDropdown()}
            keyToString={({ value }) => value}
            onChange={getPMKitValue}
            placeholder={{
              displayValue: t('PM_KIT_MODEL2'),
              value: 'placeholder'
            }}
            selected={selectedPMKit}
            className={pmKitErrors ? 'dropdown-invalid' : ''}
          />
          {pmKitErrors && <p className="error">{t('PM_KIT_SERVICE_ERR')}</p>}
        </>
      )}
    </div>
  );
};

ServiceOptionsDropdown.propTypes = {
  selectedUnit: PropTypes.string,
  setSelectedUnit: PropTypes.func,
  pmKitOptions: PropTypes.shape({
    data: PropTypes.shape({
      ssroBundlesExist: PropTypes.bool,
      bundleData: PropTypes.shape({
        bundles: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string,
            description: PropTypes.string,
            serviceOptionID: PropTypes.string,
            url: PropTypes.string,
            isPMKit: PropTypes.bool
          })
        )
      })
    }),
    isLoading: PropTypes.bool
  }),
  pmKitErrors: PropTypes.shape({ message: PropTypes.string }),
  itemToString: PropTypes.func,
  pmKitsList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
      serviceOptionID: PropTypes.string,
      url: PropTypes.string,
      isPMKit: PropTypes.bool
    })
  ),
  getPMKitValue: PropTypes.func,
  selectedPMKit: PropTypes.string
};

export default ServiceOptionsDropdown;
